import { createSignalRContext } from 'react-signalr';

import { ISignalRHub } from '@c/notifications/types';

export const SignalRContext = createSignalRContext<ISignalRHub>({ shareConnectionBetweenTab: true });
